import Request from '../../../../src/core/gd/data/request'
import {CustomFieldAccess} from "../../model2/custom-field/@const";

export default class ApiCustomFields {

    constructor() {

    }

    // New

    static update(customFieldId:ID, data:any) {
        return new Request(this,'put','company/'+gd.companyId+'/custom-field/'+customFieldId,{
            name        : data.name,
            access      : data.access,
            params      : data.params
        });
    }

    static createCompanyCustomField(name:string, type:any, access:CustomFieldAccess, params:any) {
        return new Request(this,'post','company/'+gd.companyId+'/custom-fields',{
            name        : name,
            type        : type,
            access      : access,
            params      : params
        });
    }

    // Original

    addCustomFieldToTaskType(companyId:ID, taskTypeId:ID, customFieldId:ID) {
        return new Request(this,'post','company/'+companyId+'/task-type/'+taskTypeId+'/custom-fields', {customFieldId: customFieldId});
    }

    // deprecated - use static createCompanyCustomField
    addCustomFieldToCompany(companyId:ID, name:string, type:any, access:CustomFieldAccess, params:any) {
        return new Request(this,'post','company/'+companyId+'/custom-fields',{
            name: name,
            type: type,
            access: access,
            params: params
        });
    }

    editCustomFieldToCompany(companyId:ID, customFieldId:ID, data:any) {
        return new Request(this,'put','company/'+companyId+'/custom-field/'+customFieldId,{
            name: data.name,
            type: data.type,
            access: data.access,
            params: data.params
        });
    }

    removeCustomFieldFromProject(projectId:ID, customFieldId:ID) {
        return new Request(this,'delete','project/'+projectId+'/custom-field/'+customFieldId);
    }

    saveCustomFieldsOrderForProject(projectId:ID, data:any) {
        return new Request(this,'put','project/'+projectId+'/custom-fields', {
            customFields: data
        });
    }

    addCustomFieldToProject(projectId:ID, customFieldId:ID) {
        return new Request(this,'post','project/'+projectId+'/custom-fields', {customFieldId: customFieldId});
    }

    removeCustomFieldFromTaskType(organizationId:ID, taskTypeId:ID, customFieldId:ID) {
        return new Request(this,'delete','company/'+organizationId+'/task-type/'+taskTypeId+'/custom-field/'+customFieldId);
    }

    saveCustomFieldsOrderForTaskType(organizationId:ID, taskTypeId:ID, data:any) {
        return new Request(this,'put','company/'+organizationId+'/task-type/'+taskTypeId+'/custom-fields', {
            customFields: data
        });
    }

    deleteCustomField(companyId:ID, customFieldId:ID) {
        return new Request(this,'delete','company/'+companyId+'/custom-field/'+customFieldId);
    }

    setCustomFields(companyId:ID, customFields:any[]) {
        return new Request(this,'put','company/'+companyId+'/custom-fields', {
            customFields: customFields
        });
    }
}